import { createSlice } from "@reduxjs/toolkit";

const isBrowserSlice = createSlice({
  name: "isBrowser",
  initialState: false,
  reducers: {
    setIsBrowser: (_state) => {
      return true;
    },
  },
});

export const { setIsBrowser } = isBrowserSlice.actions;

export default isBrowserSlice.reducer;
